<script setup lang="ts">
import AppFooter from '#/components/layout/AppFooter.vue';
import AppHeader from '#/components/layout/AppHeader.vue';

/**
 * 기본 레이아웃 — 전 페이지 공통 셸(Header + Footer).
 * 본문은 <slot/>(App.vue 의 RouterView). shell.css 의 전역 셸 구조 이관.
 * 2026-10 커머스 랜딩 개편(Figma 포트)으로 상단 메시지띠(TopStrip)는 제외 — 알약형 헤더가
 * 페이지 바탕 위에 바로 뜨는 구성이라 다크 띠가 어울리지 않는다(컴포넌트 파일은 보존).
 */
</script>

<template>
  <div class="flex min-h-screen flex-col bg-lp-page">
    <AppHeader />
    <main class="flex-1">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>
